import React, { useState, forwardRef, useEffect } from 'react';
import * as XLSX from 'xlsx';
import apiService from '../../../Auth/apiService';
import { useNavigate, NavLink } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Row, Col, Button } from 'react-bootstrap';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import DatePicker from 'react-datepicker';
import MenuAdministrativos from './MenuAdministrativos';
import { useAuth } from '../../../Auth/AuthContext';
import { FaCalendar, FaFileCsv, FaFileExcel, FaList, FaSearch } from 'react-icons/fa';


const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input value={value} readOnly className='widthCalendar' data-tooltip-id='tooltiparriba' data-tooltip-content="Seleccionte fecha" tabIndex={-1} style={{ pointerEvents: 'none', background: 'transparent', border: 'none', width: 'auto' }} />
        <FaCalendar/>
    </button>
    ));

export default function InformeRetornos(){
    const { token, rol } = useAuth();
    const navigate = useNavigate();
    const fecha = new Date();
    const [Cargando, setCargando] = useState(false);
    const [datosRetorno, setDatosRetorno] = useState([]);

    async function downloadExcel(data, titulo) {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        const excelBuffer = await XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const currentDate = new Date().toISOString().split('T')[0];
        if(titulo === undefined || titulo === null || titulo === "") {
            titulo = "Datos_Retornos";
        }
        saveAs(blob, `${titulo}_${currentDate}.xlsx`);
    };

    const { control, handleSubmit, watch, formState: { errors }} = useForm({
        defaultValues: { 
            FechaInicial: fecha, 
            FechaFinal: fecha
        }
    });
    const [swalProps, setSwalProps] = useState();
    
    async function onSubmit(data) {
        await fetchData(
            data.FechaInicial.toLocaleDateString('en-CA'), 
            data.FechaFinal.toLocaleDateString('en-CA')
        );
    }
    async function fetchData(FechaI, FechaF) {
        setCargando(true);
        const url = `/caracterizacion/informes/estadisticosretorno?FechaInicio=${FechaI}&FechaFinal=${FechaF}`;        
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosRetorno(result);
        } catch (error) {
            if (error.response && error.response.status === 409) {
                setSwalProps({
                    show: true,
                    title: 'Advertencia',
                    text: error.response.data.message || 'No se encontraron registros para las fechas seleccionadas.',
                    icon: 'warning',
                });
            } else {
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo obtener la informaci&oacute;n de retornos.',
                    showConfirmButton: true,
                });
            }
        } finally {
            setCargando(false);
        }
    }
    function verAtencion(row, verAtencionesPersona) {
        return (
            <div>
                <button 
                    type="button" 
                    onClick={() => verAtencionesPersona(row)} 
                    style={{ backgroundColor: 'skyblue' }} 
                    data-tooltip-id='tooltiparriba'
                    data-tooltip-content="Ver atenciones de la persona"
                >
                    <FaList />
                </button>
            </div>
        );
    }
    
    async function exportarCSV() {
        setCargando(true);
        const FechaI = watch('FechaInicial').toLocaleDateString('en-CA')
        const FechaF = watch('FechaFinal').toLocaleDateString('en-CA')
        const url = `/caracterizacion/informes/estadisticosretorno?FechaInicio=${FechaI}&FechaFinal=${FechaF}&csv=${true}`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'retornos.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
    }
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    useEffect(() => {
        if (rol !== '2') {
          navigate('/dashboard');
        }
      }, [rol, navigate]);
    const [filters, setFilters] = useState({
        comuna: '',
    });
    // Filtrado de datos
    const filteredData = datosRetorno.filter(row =>
        (!filters.comuna || row.COMUNA === filters.comuna)        
    );

    // Paginación
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 50;
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const paginatedData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [filters, datosRetorno]);
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Informe Retornos</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/caracterizacion/informesadministrativos" > Administrativos</NavLink></li>
                        <li className="breadcrumb-item active"> Retornos</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuAdministrativos/>
                    <div className="row">
                        <div className="col-md-12">
                            <div className='card'>
                                <div className='card-header'> 
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Row className="mb-12">
                                            <Col md={2}>
                                                <label htmlFor="FechaInicial">
                                                <Controller
                                                    control={control}
                                                    name="FechaInicial"
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                            <DatePicker
                                                            id="FechaInicial"
                                                            placeholderText="fecha"
                                                            onChange={(date) => field.onChange(date)}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value}
                                                            customInput={<CustomInput />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            />
                                                        </div>
                                                    )}
                                                /></label>
                                                {errors.FechaInicial && <p style={{color: 'red'}}>Fecha inicial</p>}
                                            </Col>
                                            <Col md={2}>
                                            <label htmlFor="FechaFinal">
                                                <Controller
                                                    control={control}
                                                    name="FechaFinal"
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                            <DatePicker
                                                            id="FechaFinal"
                                                            placeholderText="fecha"
                                                            onChange={(date) => field.onChange(date)}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value}
                                                            customInput={<CustomInput />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            />
                                                        </div>
                                                    )}
                                                />{errors.FechaFinal && <p style={{color: 'red'}}>Fecha final</p>}
                                            </label>
                                            </Col>
                                            <Col md={6}>
                                                <Button type="submit" variant="primary" className="mb-2 me-2">
                                                    <FaSearch /> Buscar
                                                </Button>
                                                <Button variant="primary" className="mb-2 me-2" onClick={exportarCSV}>
                                                    <FaFileCsv /> Exportar CSV
                                                </Button>
                                                {filteredData && filteredData.length > 0 && (
                                                    <Button variant="primary" className="mb-2 me-2" onClick={() => downloadExcel(filteredData, 'Estadisticos_Retornos')}>
                                                        <FaFileExcel /> Exportar Excel
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>
                                    </form>
                                    
                                </div>

                                {datosRetorno && datosRetorno.length > 0 && <div className="card-body table-responsive p-0">
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '1rem 0' }}>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Anterior
                                        </button>
                                        <span style={{ margin: '0 1rem' }}>
                                            Página {currentPage} de {totalPages}
                                        </span>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Acciones</th>
                                                <th>TIPODOCUMENTO</th>
                                                <th>DOCUMENTO</th>
                                                <th>PRIMERAPELLIDO</th>
                                                <th>SEGUNDOAPELLIDO</th>
                                                <th>PRIMERNOMBRE</th>
                                                <th>SEGUNDONOMBRE</th>
                                                <th>FECHANACIMIENTO</th>
                                                <th>SEXO</th>
                                                <th>ORIENTACIONSEXUAL</th>
                                                <th>IDENTIDADGENERO</th>
                                                <th>ETNIA</th>
                                                <th>DISCAPACIDAD</th>
                                                <th>HECHOVICTIMIZANTE</th>
                                                <th>HABITANTECALLE</th>
                                                <th>CAMPESINO</th>
                                                <th>ESCOLARIDAD</th>
                                                <th>REGIMENAFIMIACIONSALUD</th>
                                                <th>ESTRAOSOCIOECONOMICO</th>
                                                <th>ZONA</th>
                                                <th>AREA</th>
                                                <th>BARRIO</th>
                                                <th>COMUNA</th>
                                                <th>FECHAINGRESOPROGRAMA</th>
                                                <th>PAISNACIMIENTO</th>
                                                <th>CABEZAFAMILIA</th>
                                                <th>PARENTESCO</th>
                                                <th>IDDETALLEATENCION</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.comuna}
                                                        onChange={e => setFilters(f => ({ ...f, comuna: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datosRetorno.map(row => row.COMUNA).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedData.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td>{verAtencion(row, verAtencionesPersona)}</td>
                                                    <td>{row.TIPODOCUMENTO}</td>
                                                    <td>{row.DOCUMENTO}</td>
                                                    <td>{row.PRIMERAPELLIDO}</td>
                                                    <td>{row.SEGUNDOAPELLIDO}</td>
                                                    <td>{row.PRIMERNOMBRE}</td>
                                                    <td>{row.SEGUNDONOMBRE}</td>
                                                    <td>{row.fechanacimiento}</td>
                                                    <td>{row.SEXO}</td>
                                                    <td>{row.orientacionsexual}</td>
                                                    <td>{row.identidadgenero}</td>
                                                    <td>{row.ETNIA}</td>
                                                    <td>{row.DISCAPACIDAD}</td>
                                                    <td>{row.HECHOVICTIMIZANTE}</td>
                                                    <td>{row.habitantecalle}</td>
                                                    <td>{row.campesino}</td>
                                                    <td>{row.ESCOLARIDAD}</td>
                                                    <td>{row.regimenafiliacionsalud}</td>
                                                    <td>{row.estratosocioeconomico}</td>
                                                    <td>{row.ZONA}</td>
                                                    <td>{row.area}</td>
                                                    <td>{row.BARRIO}</td>
                                                    <td>{row.COMUNA}</td>
                                                    <td>{row.fechaingresoprograma}</td>
                                                    <td>{row.paisnacimiento}</td>
                                                    <td>{row.CABEZAFAMILIA}</td>
                                                    <td>{row.PARENTESCO}</td>
                                                    <td>{row.DETALLEATENCIONID}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}